import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useState } from "react";
import DateComIntervalo from "../../../../components/DateComIntervalo";
import { TFiltrosNfs } from "./ListarTodas/Listagem";
import moment from "moment";
import { formatarInputValorMonetário } from "../../../../helpers/masks";
import { desformatarValorMonetario } from "../../../../helpers/unmask";
import PaperDraggable from "../../../../components/PaperDraggable";

export default function DialogFiltrosNfs({
    open,
    filtrosAtuais,
    onClose,
    onConfirm
}: DialogFiltrosNfsProps) {

    const [internalFilters, setInternalFilters] = useState<TFiltrosNfs>(filtrosAtuais);

    const statusOptions = [
        'Aguardando',
        'Análise de divergência',
        'Aguardando chegada',
        'Recebido com sucesso',
        'Aguardando aprovação fiscal'
    ];

    const handleInsertFiltros = (prop: string, value: any) => {
        if (prop === 'situacoes') {
            if (value === "Todos") {
                value = [];
            }
        }
        setInternalFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleConfirm = (filters: TFiltrosNfs) => {

        if (filters.valor) {
            const valorLimpo = desformatarValorMonetario(filters.valor);
            filters.valor_total_maior_igual = valorLimpo;
            filters.valor_total_menor_igual = valorLimpo;
        }
        onConfirm(filters)
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Filtros</DialogTitle>
            <DialogContent>

                <Grid container spacing={2} mt={0.8}>
                    <Grid size={{xs: 12, md: 6}}>
                        <DateComIntervalo
                            data={{
                                inicial: internalFilters.data_emissao_inicio ? moment(internalFilters.data_emissao_inicio) : null,
                                final: internalFilters.data_emissao_fim ? moment(internalFilters.data_emissao_fim) : null
                            }}
                            onChangeData={(data) => {
                                handleInsertFiltros("data_emissao_inicio", data.inicial?.format("YYYY-MM-DD"))
                                handleInsertFiltros("data_emissao_fim", data.final?.format("YYYY-MM-DD"))
                            }}
                            datePickerView={['year', 'month', 'day']}
                            formatString="DD/MM/YYYY"
                            labelInput="Data de emissão"
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                        <TextField
                            label="Emissor"
                            value={internalFilters.nome_emissor_like || ""}
                            onChange={(e) => handleInsertFiltros("nome_emissor_like", e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                        <TextField
                            label="Valor"
                            value={internalFilters.valor || ""}
                            onChange={(e) => {
                                const formatedValue = formatarInputValorMonetário(e.target.value)
                                handleInsertFiltros("valor", formatedValue);
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                        <FormControl fullWidth>
                            <InputLabel id="status-select-label">Status</InputLabel>
                            <Select
                                labelId="status-select-label"
                                multiple
                                value={internalFilters.status || []}
                                onChange={(e) => handleInsertFiltros("status", e.target.value)}
                                input={<OutlinedInput label="Status" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} size="small" />
                                        ))}
                                    </Box>
                                )}
                            >
                                {statusOptions.map((status) => (
                                    <MenuItem key={status} value={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onConfirm({})}>Limpar</Button>
                <Button variant="contained" onClick={() => handleConfirm(internalFilters)}>Aplicar</Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogFiltrosNfsProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (filters: TFiltrosNfs) => void;
    filtrosAtuais: TFiltrosNfs;
}